export default __webpack_public_path__ + "static/media/no-img.26e9bc12.png";